import api from "../../../api/catalogs/failure_type.js";
import _ from 'lodash';
const namespaced = true;

const state = {
    failure_type_data: [],
};
const mutations = {
    SET_FAILURE_TYPE(state, data) {
        state.failure_type_data = data;
    },
};
const actions = {
    getFailureType(context) {
        return new Promise((resolve) => {
            api.getFailureType()
                .then(function (res) {
                    context.commit("SET_FAILURE_TYPE", res.data.data);
                    context.commit(
                        "delay_event/SET_FILTER_FAILURE_TYPE",
                        res.data.data,
                        { root: true }
                    );
                    resolve(res.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        });
    },
};

const getters = {
    getFailureType(state) {
        return _.filter(state.failure_type_data, function(o) { return o.id!=6; });
    },
    getFailureNameType(state) {
        return state.failure_type_data.map(({ id, name }) => ({ id, name }));
    },
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
};
